import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl) {
  throw new Error('REACT_APP_SUPABASE_URL is not set')
}
if (!supabaseKey) {
  throw new Error('REACT_APP_SUPABASE_ANON_KEY is not set')
}

export const supabase = createClient(supabaseUrl, supabaseKey)
